<template>
    <v-app-bar
        class="dds-top-nav"
        :class="[backGroundColor]"
        height="65"
    >
        <v-sheet
            class="bg-neutral-50 d-flex align-center justify-center"
            height="100%"
            width="256"
        >
            <v-img
                :src="kpmgLogoBlue"
                alt="KPMG Logo"
                height="36"
            ></v-img>
        </v-sheet>
        <v-app-bar-title v-if="showPath" class="text-primary">
            <v-icon v-if="appIcon != undefined" :icon="appIcon"/>
            {{ appTitle }}
            <template v-if="pageTitle != undefined">
                / <span class="font-weight-bold">{{ pageTitle }}</span>
            </template>
        </v-app-bar-title>
        <template v-slot:append>
            <slot v-if="$slots.append" name="append"/>
            <template v-else-if="employeeName != undefined">
                <v-app-bar-title v-if="employeeName" class="text-primary pr-3">

                </v-app-bar-title>
            </template>
            <slot name="last"></slot>
        </template>
    </v-app-bar>

</template>

<script lang="ts">
import {computed, defineComponent} from "vue"

import kpmgLogoBlue from '@/assets/kpmg_logo_blue.svg'
import InitialIcon from "@/components/InitialIcon.vue";
export default defineComponent({
    components: {InitialIcon},
    setup() {

        const backGroundColor = computed(()=>{
            return import.meta.env.VITE_APP_COLOR
        })
        return {
            kpmgLogoBlue,
            backGroundColor
        }
    },
    props: {
        appTitle: {
            type: String,
            required: true,
        },
        pageTitle: {
            type: String,
        },
        appIcon: {
            type: String,
        },
        employeeName: {
            type: String
        },
        showPath: {
            type: Boolean,
            default: true
        }
    },
})
</script>
<style scoped lang="scss">
:deep(.fab-btn button) {
    padding-right: 2px !important;
}
div:deep(.v-application--wrap) {
    min-height:calc(100vh - 65px) !important;
}
</style>
